import { InvoiceHeader } from './invoice-header.model';
import { InvoiceLine } from './invoice-line.model';
import { InvoiceOrganization } from './invoice-organization.model';
import { InvoicePlace } from './invoice-place.model';

export class Invoice {
  id: number;
  invoicedEntity: string|any;
  process = 'DKX';
  header: InvoiceHeader;
  supplier: InvoiceOrganization;
  customer: InvoiceOrganization;
  supplierEco: InvoicePlace;
  customerEco: InvoicePlace;
  lines: InvoiceLine[];

  constructor(values= {}) {
    Object.assign(this, values);
    this.header = this.header ? new InvoiceHeader(this.header) : new InvoiceHeader();
    this.supplier = this.supplier ? new InvoiceOrganization(this.supplier) : new InvoiceOrganization();
    this.customer = this.customer ? new InvoiceOrganization(this.customer) : new InvoiceOrganization();
    this.supplierEco = this.supplierEco ? new InvoicePlace(this.supplierEco) : new InvoicePlace();
    this.customerEco = this.customerEco ? new InvoicePlace(this.customerEco) : new InvoicePlace();

    if (this.lines) {
      for (let line of this.lines) {
        line = line ? new InvoiceLine(line) : line;
      }
    }
  }

  /**
   * Returns total tax-free amount of this invoice
   *
   * @return number
   */
  getTotalAmount(): number {
    let total = 0;

    for (const line of this.lines) {
      total += line.price.invoiceAmount.unitAmount * line.price.quantity;
    }

    return total;
  }
}
